
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo-defi-framework/api/legacy/ban_pubkey",
      function () {
        return require("private-next-pages/en/docs/komodo-defi-framework/api/legacy/ban_pubkey/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo-defi-framework/api/legacy/ban_pubkey"])
      });
    }
  